/**
 * Sprint 11.12 \u2014 Live Client Report page.
 *
 * Thin wrapper: confirms the email gate, fetches the public payload,
 * adapts it via the shared `clientReportAdapter`, renders `MagazineReport`.
 */
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { v1Get } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { MagazineReport } from '@/components/clientReport';
import { adaptLivePayloadToMagazine } from '@/lib/clientReportAdapter';

export default function ClientReport() {
  const { token } = useParams();
  const verifiedEmail = typeof window !== 'undefined'
    ? sessionStorage.getItem(`client-${token}`)
    : null;
  const verified = !!verifiedEmail;

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['client-report', token, verifiedEmail],
    queryFn: () => v1Get(
      `/client-report/${token}?email=${encodeURIComponent(verifiedEmail)}`,
    ),
    enabled: verified,
    staleTime: 30_000,
  });

  if (!verified) return <Navigate to={`/client/${token}`} replace />;

  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background p-6">
        <Card className="card-elevated"><CardContent className="p-8 text-sm text-muted-foreground">
          Loading report\u2026
        </CardContent></Card>
      </div>
    );
  }
  if (isError) {
    return (
      <div className="grid min-h-screen place-items-center bg-background p-6">
        <Card className="card-elevated"><CardContent className="p-8 text-sm text-rose-700">
          Unable to load report: {error?.response?.data?.detail || error?.message || 'unknown error'}
        </CardContent></Card>
      </div>
    );
  }

  return (
    <MagazineReport
      data={adaptLivePayloadToMagazine(data)}
      isDemo={false}
      shareToken={token}
      clientFacing
    />
  );
}
